import {saveAs} from 'file-saver';
import ExcelJS from 'exceljs';
import {CONSTANTS} from '../constants';

// to check if phone number is valid or not
const validatePhone = phone => {
  const phoneRegex = CONSTANTS.REGEX.PHONE_NUMBER;
  return phoneRegex.test(phone);
};

const validateWebURL = url => {
  const urlRegex = CONSTANTS.REGEX.WEB_URL;
  return urlRegex.test(url);
};

// to check if special characters includes in string
const isSpecialCharacterIncludes = str => {
  const strRegex = /[!@#$₹%^&*()+= [\]{}\\|<>/?]/;
  return strRegex.test(str);
};

// to check if zipcode is valid or not
const isValidZipCode = zipCode => {
  const usZipCodeRegex = /^\d{5}(?:-\d{4})?$/;
  return usZipCodeRegex.test(zipCode);
};

const isValidLocation = location => {
  const locationRegex = /^[a-zA-Z\s]+$/;
  return locationRegex.test(location.trim()); // Trim spaces and test against regex
};

// to check if email is valid or not
const validateEmail = email => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  return emailRegex.test(email);
};

// to check if object property is empty or not
function isEmptyObjectValues(obj, excludeKeys = []) {
  for (const key in obj) {
    if (excludeKeys.includes(key)) {
      continue;
    }
    if (Array.isArray(obj[key])) {
      if (obj[key].length === 0) {
        return true;
      }
    } else if (typeof obj[key] === 'string') {
      if (obj[key].trim() === '') {
        return true;
      }
    }
  }
  return false;
}

function disableDatesByWeekDay(dayOfWeek, date) {
  let dayOfWeeks = dayOfWeek;
  let weekNo;
  if (dayOfWeeks === 'monday') {
    weekNo = 1;
  }
  if (dayOfWeeks === 'tuesday') {
    weekNo = 2;
  }
  if (dayOfWeeks === 'wednesday') {
    weekNo = 3;
  }
  if (dayOfWeeks === 'thursday') {
    weekNo = 4;
  }
  if (dayOfWeeks === 'friday') {
    weekNo = 5;
  }
  if (dayOfWeeks === 'saturday') {
    weekNo = 6;
  }
  if (dayOfWeeks === 'sunday') {
    weekNo = 0;
  }
  return new Date(date).getDay() !== weekNo;
}

function allFieldsHaveValue(obj) {
  for (let key in obj) {
    if (obj[key] === null || obj[key] === undefined || obj[key] === '') {
      return false;
    }
  }
  return true;
}

// to check what file type
function isValidFile(type, file) {
  if (type === 'image') {
    if (file.type === 'image/png' || file?.type === 'image/jpg' || file?.type === 'image/jpeg' || file?.type === 'image/svg' || file?.type === 'image/webp' || file?.type === 'image/*') {
      return true;
    } else {
      return false;
    }
  } else {
    if (file.type === 'application/pdf' || file?.type === 'application/vnd.ms-excel' || file?.type === '.xls' || file?.type === '.xlsx' || file?.type === '.csv') {
      return true;
    } else {
      return false;
    }
  }
}

// timer formatter
function formatTime(timeInSeconds) {
  const minutes = Math.floor(timeInSeconds / 60);
  const seconds = timeInSeconds % 60;
  return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
}

// capitalize the first character
function capitalizeWords(str) {
  const words = str.split(' ');
  const capitalizedWords = words.map(word => {
    if (word.length > 0) {
      return word.charAt(0).toUpperCase() + word.slice(1);
    } else {
      return '';
    }
  });
  return capitalizedWords.join(' ');
}

function mergeConsecutiveSteps(data) {
  const mergedData = [];
  for (let i = 0; i < data.length; i += 2) {
    if (i + 1 < data.length) {
      const idPair = `${data[i].id},${data[i + 1].id}`;
      const questionPair = `${data[i].question},${data[i + 1].question}`;
      const stepCount = `${i + 1},${i + 2}`;
      const updated_by = `${data[i].updated_by}`;
      mergedData.push({
        id: idPair,
        question: questionPair,
        stepCount,
        updated_by
      });
    } else {
      // If there's only one item left, just push it as is
      mergedData.push(data[i]);
    }
  }
  return mergedData;
}

// to get the overall growth report
function getOverallGrowthReport(reportData, orgName, startYear, endYear) {
  // Create a new workbook and worksheet
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet('Overall Growth Report');
  for (let i = 1; i <= 17; i++) {
    let column = worksheet.getColumn(i);
    column.width = 20;
  }
  worksheet.addRow([]);
  const title1 = worksheet.addRow(['Growth Report']);
  title1.font = {size: 16, bold: true};
  title1.alignment = {horizontal: 'center', vertical: 'middle'};
  worksheet.mergeCells(`A${title1.number}:O${title1.number}`);

  const title2 = worksheet.addRow([orgName]);
  title2.font = {size: 14, bold: true};
  title2.alignment = {horizontal: 'center', vertical: 'middle'};
  worksheet.mergeCells(`A${title2.number}:O${title2.number}`);

  const title3 = worksheet.addRow([`${startYear} – ${endYear}`]);
  title3.font = {size: 12};
  title3.alignment = {horizontal: 'center', vertical: 'middle'};
  worksheet.mergeCells(`A${title3.number}:O${title3.number}`);

  worksheet.addRow([]);

  let rowd1 = worksheet.addRow(['', '', '', 'Year One', '', '', 'Year Two', '', '', 'Year Three', '', '', 'Stalled', '', '']);
  rowd1.alignment = {horizontal: 'center', vertical: 'middle'};
  rowd1.border = {
    top: {style: 'thin'},
    left: {style: 'thin'},
    right: {style: 'thin'},
    bottom: {style: 'thickThinRest'}
  };
  rowd1.fill = {
    type: 'pattern',
    pattern: 'solid',
    fgColor: {argb: 'cccacf'}
  };
  let rowd2 = worksheet.addRow(['Year', 'Total', '', 'Started', 'Finished', '', 'Started', 'Finished', '', 'Started', 'Finished', '', 'No.', '% of Stalled', '']);
  rowd2.alignment = {horizontal: 'center', vertical: 'middle'};
  rowd2.border = {
    top: {style: 'thin'},
    left: {style: 'thin'},
    right: {style: 'thin'},
    bottom: {style: 'thickThinRest'}
  };
  rowd2.fill = {
    type: 'pattern',
    pattern: 'solid',
    fgColor: {argb: 'cccacf'}
  };

  worksheet.mergeCells('A1:N1');

  // Merge cells for D1, D2, and D3
  worksheet.mergeCells('D6:E6');
  worksheet.mergeCells('G6:H6');
  worksheet.mergeCells('J6:K6');
  worksheet.mergeCells('M6:N6');

  // // Iterate over the properties of reportData
  // Object.entries(reportData).forEach(([year, yearData]) => {
  //   worksheet.addRow([year, yearData?.Total, '', yearData?.D1_started, yearData?.D1_finished, '', yearData?.D2_started, yearData?.D2_finished, '', yearData?.D3_started, yearData?.D3_finished, '', yearData?.stalled_count, Number(yearData?.stalled_percent).toFixed(2) + ' %', '']);
  // });

  // perform this for alignment and border styling
  let rowIndex = worksheet.lastRow.number + 1;
  Object.entries(reportData)
    .filter(([key]) => !['orgName', 'startYear', 'endYear', 'SuccessRateByTraining', 'successRateByLeaders'].includes(key))
    .forEach(([year, yearData]) => {
      const row = worksheet.getRow(rowIndex);
      row.values = [year, yearData?.Total ?? '0', '', yearData?.D1_started ?? '0', yearData?.D1_finished ?? '0', '', yearData?.D2_started ?? '0', yearData?.D2_finished ?? '0', '', yearData?.D3_started ?? '0', yearData?.D3_finished ?? '0', '', yearData?.stalled_count ?? '0', yearData?.stalled_percent ? Number(yearData.stalled_percent).toFixed(2) + ' %' : '0 %', ''];

      // Apply alignment and border styling
      row.alignment = {horizontal: 'center', vertical: 'middle'};
      row.border = {
        top: {style: 'thin'},
        left: {style: 'thin'},
        right: {style: 'thin'},
        bottom: {style: 'thin'}
      };

      row.height = 20;
      rowIndex++;
    });

  worksheet.addRow([]);
  worksheet.addRow([]);
  // Add header row for both sections side by side
  let rowh4 = worksheet.addRow(['Success Rate by Training', '', '', '', '', '', '', '', 'Success Rate by Leader Profile']);
  rowh4.fill = {
    type: 'pattern',
    pattern: 'solid',
    fgColor: {argb: 'FF808080'}
  };
  rowh4.alignment = {horizontal: 'center'};
  worksheet.mergeCells('A' + rowh4.number + ':F' + rowh4.number);
  worksheet.mergeCells('I' + rowh4.number + ':N' + rowh4.number);

  // Add criteria headers side by side
  let rowd42 = worksheet.addRow(['Criteria', '', '', 'Completion', 'Drop', 'Stall', '', '', 'Criteria', '', '', 'Completion', 'Drop', 'Stall']);
  rowd42.alignment = {horizontal: 'center', vertical: 'middle'};
  rowd42.fill = {
    type: 'pattern',
    pattern: 'solid',
    fgColor: {argb: 'cccacf'}
  };
  rowd42.border = {
    top: {style: 'thin'},
    left: {style: 'thin'},
    right: {style: 'thin'},
    bottom: {style: 'thickThinRest'}
  };

  // Remove fill and borders for columns G and H in rowh4
  ['G', 'H'].forEach(col => {
    const cell = worksheet.getCell(`${col}${rowh4.number}`);
    cell.fill = null;
    cell.border = {};
  });

  // Remove fill and borders for columns G and H in rowd42
  ['G', 'H'].forEach(col => {
    const cell = worksheet.getCell(`${col}${rowd42.number}`);
    cell.fill = null;
    cell.border = {};
  });

  // Merge cells accordingly (if needed)
  worksheet.mergeCells('A' + rowd42.number + ':C' + rowd42.number);
  worksheet.mergeCells('I' + rowd42.number + ':K' + rowd42.number);

  // DEFINE CRITERIA VALUES
  let trainingCriteria = ['Read How to Make Disciples', 'Took Any Workshop', 'Read How to Make Disciples + Took Workshop', 'Read How to Make Disciples + Coaching', 'Read How to Make Disciples + Took Workshop + Coaching', 'Attended Workshop + Coaching'];

  let leaderCriteria = ['Previously Discipled', 'SD Disciple', 'SD Disciple + Workshop', 'SD Disciple + Coaching', 'SD Disciple + Took Workshop + Coaching'];

  // DATA BLOCK
  const trainingData = reportData['D4'] || {};
  const leaderData = reportData['D5'] || {};
  let maxRows = Math.max(trainingCriteria.length, leaderCriteria.length);
  let currentRow = worksheet.lastRow.number + 1;

  for (let i = 0; i < maxRows; i++) {
    const tKey = trainingCriteria[i] || '';
    const tRow = reportData.SuccessRateByTraining?.[tKey] || {};
    const lKey = leaderCriteria[i] || '';
    let lRow = {};
    let leaderKeyMapping = {
      'Previously Discipled': 'previouslyDiscipled',
      'SD Disciple': 'sdDisciple',
      'SD Disciple + Workshop': 'sdDiscipleWorkshop',
      'SD Disciple + Coaching': 'sdDiscipleCoaching',
      'SD Disciple + Took Workshop + Coaching': 'sdDiscipleWorkshopCoaching'
    };

    const mappedKey = leaderKeyMapping[lKey];
    if (mappedKey && reportData.successRateByLeaders?.[mappedKey]) {
      const raw = reportData.successRateByLeaders[mappedKey];
      lRow = {
        completion_count: raw.completion != null ? `${raw.completion.toFixed(0)}%` : '0%',
        drop_count: raw.drop != null ? `${raw.drop.toFixed(0)}%` : '0%',
        stall_count: raw.stall != null ? `${raw.stall.toFixed(0)}%` : '0%'
      };
    }
    const compKey = Object.keys(tRow).find(k => k.startsWith('Completion')) || '';
    const dropKey = Object.keys(tRow).find(k => k.startsWith('Drop')) || '';
    const stallKey = Object.keys(tRow).find(k => k.startsWith('Stall')) || '';

    const isLeaderRowEmpty = !lRow?.completion_count && !lRow?.drop_count && !lRow?.stall_count;

    if (tKey || lKey) {
      const row = worksheet.addRow([
        tKey, '', '',
        tRow[compKey] ?? '0%',
        tRow[dropKey] ?? '0%',
        tRow[stallKey] ?? '0%',
        '', '',
        lKey, '', '',
        !isLeaderRowEmpty ? lRow?.completion_count ?? '0%' : '',
        !isLeaderRowEmpty ? lRow?.drop_count ?? '0%' : '',
        !isLeaderRowEmpty ? lRow?.stall_count ?? '0%' : '',
        '', ''
      ]);

    row.alignment = {horizontal: 'center', vertical: 'middle', wrapText: true};
    row.border = {
      top: {style: 'thin'},
      left: {style: 'thin'},
      right: {style: 'thin'},
      bottom: {style: 'thin'}
    };
    row.height = 20;

    // Merge criteria block cells for current row
    worksheet.mergeCells(`A${row.number}:C${row.number}`); // Training criteria cell
    worksheet.mergeCells(`I${row.number}:K${row.number}`); // Leader criteria cell

    // Remove border from G and H columns
      ['G', 'H'].forEach(col => {
        const cell = worksheet.getCell(`${col}${row.number}`);
        cell.border = {};
      });
    }
  }

  // Generate the Excel file
  workbook.xlsx.writeBuffer().then(buffer => {
    // Convert buffer to Blob
    const blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    });

    // Save Blob as file
    saveAs(blob, 'Overall_Growth_Report.xlsx');
  });
}

function getYearReport(reportData, orgName, startYear, endYear) {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet('Yearly Report');

  for (let i = 1; i <= 17; i++) worksheet.getColumn(i).width = 20;

  // === Report Title Section ===
  worksheet.addRow([]);
  const title1 = worksheet.addRow(['Progress Report']);
  title1.font = {size: 16, bold: true};
  title1.alignment = {horizontal: 'center'};
  worksheet.mergeCells(`A${title1.number}:Q${title1.number}`);

  const title2 = worksheet.addRow([orgName]);
  title2.font = {size: 14, bold: true};
  title2.alignment = {horizontal: 'center'};
  worksheet.mergeCells(`A${title2.number}:Q${title2.number}`);

  const title3 = worksheet.addRow([`${startYear} – ${endYear}`]);
  title3.font = {size: 12};
  title3.alignment = {horizontal: 'center'};
  worksheet.mergeCells(`A${title3.number}:Q${title3.number}`);
  // Add a blank row at the top
  worksheet.addRow([]);

  // Utility function to create each year block
  const addYearBlock = (title, columns, mergeInstructions, dataKey) => {
    const startRow = worksheet.lastRow.number + 1;

    // Title Row
    let headerRow = worksheet.addRow([title]);
    headerRow.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: {argb: 'FF808080'}
    };
    headerRow.alignment = {horizontal: 'center'};
    worksheet.mergeCells(`A${headerRow.number}:Q${headerRow.number}`);

    worksheet.addRow(['']);

    // Main Category Headers
    let mainHeader = worksheet.addRow(columns.mainHeader);
    mainHeader.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: {argb: 'cccacf'}
    };
    mainHeader.alignment = {horizontal: 'center', vertical: 'middle'};
    mainHeader.border = {
      top: {style: 'thin'},
      left: {style: 'thin'},
      right: {style: 'thin'},
      bottom: {style: 'thickThinRest'}
    };

    // Sub-Headers
    let subHeader = worksheet.addRow(columns.subHeader);
    subHeader.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: {argb: 'cccacf'}
    };
    subHeader.alignment = {horizontal: 'center', vertical: 'middle'};
    subHeader.border = {
      top: {style: 'thin'},
      left: {style: 'thin'},
      right: {style: 'thin'},
      bottom: {style: 'thickThinRest'}
    };

    // Merging header cells
    mergeInstructions.forEach(([start, end]) => {
      worksheet.mergeCells(`${start}${mainHeader.number}:${end}${mainHeader.number}`);
    });

    // Data Rows
    const data = reportData[dataKey];
    if (data) {
      Object.entries(data).forEach(([year, values]) => {
        let row = worksheet.addRow([
          year,
          values?.total ?? '0',
          '',
          values?.finished_count ?? '0',
          values?.finished_percent ? Number(values?.finished_percent).toFixed(2) + '%' : '0',
          '',
          values?.dropped_count ?? '0',
          values?.dropped_percent ? Number(values?.dropped_percent).toFixed(2) + '%' : '0',
          '',
          values?.moved_D2_count ?? values?.moved_D3_count ?? values?.going_to_make_count ?? '0',
          values?.moved_D2_percent ? Number(values?.moved_D2_percent).toFixed(2) + '%' : values?.moved_D3_percent ? Number(values?.moved_D3_percent).toFixed(2) + '%' : values?.going_to_make_percent ? Number(values?.going_to_make_percent).toFixed(2) + '%' : '0',
          '',

          values?.stalled_count ?? '0',
          values?.stalled_percent ? Number(values?.stalled_percent).toFixed(2) + '%' : '0',
          '',
          // Optional extra metric
          values?.gap_year_making_disciples_count ?? '',
          values?.gap_percent ? Number(values?.gap_percent).toFixed(2) + '%' : '',
          ''
        ]);

        row.alignment = {horizontal: 'center', vertical: 'middle'};
        row.border = {
          top: {style: 'thin'},
          left: {style: 'thin'},
          right: {style: 'thin'},
          bottom: {style: 'thin'}
        };
        row.height = 20;
      });
    }
    worksheet.addRow([]);
    worksheet.addRow([]);
  };

  // === Call Year One Section ===
  addYearBlock(
    'First Year Disciple Acquisition & Progression',
    {
      mainHeader: ['', '', '', 'Finished', '', '', 'Dropped', '', '', 'Moved to Year Two', '', '', 'Stalled', ''],
      subHeader: ['Year', 'Starts', '', 'No.', '% of Total', '', 'No.', '% of Total', '', 'No.', '% of Finished', '', 'No.', '% of Finished', '']
    },
    [
      ['D', 'E'],
      ['G', 'H'],
      ['J', 'K'],
      ['M', 'N']
    ],
    'D1'
  );

  // === Call Year Two Section ===
  addYearBlock(
    'Second Year Disciple Progression',
    {
      mainHeader: ['', '', '', 'Finished', '', '', 'Dropped', '', '', 'Moved to Year Three', '', '', 'Stalled', '', '', 'Gap Year Making Disciples', ''],
      subHeader: ['Year', 'Starts', '', 'No.', '% of Total', '', 'No.', '% of Total', '', 'No.', '% of Finished', '', 'No.', '% of Finished', '', 'No.', '% of Finished', '']
    },
    [
      ['D', 'E'],
      ['G', 'H'],
      ['J', 'K'],
      ['M', 'N'],
      ['P', 'Q']
    ],
    'D2'
  );

  // === Call Year Three Section ===
  addYearBlock(
    'Third Year Disciple Progression',
    {
      mainHeader: ['', '', '', 'Finished', '', '', 'Dropped', '', '', 'Going to Make Disciples', '', '', 'Stalled', ''],
      subHeader: ['Year', 'Starts', '', 'No.', '% of Total', '', 'No.', '% of Total', '', 'No.', '% of Finished', '', 'No.', '% of Finished', '']
    },
    [
      ['D', 'E'],
      ['G', 'H'],
      ['J', 'K'],
      ['M', 'N']
    ],
    'D3'
  );

  // === Save the file ===
  workbook.xlsx.writeBuffer().then(buffer => {
    const blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    });
    saveAs(blob, 'Yearly_Report.xlsx');
  });
}

// to get the Organisational report
function getOrganisationReport(reportData, startYear, endYear) {
  // Create a new workbook and worksheet
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet('SD Movement Growth and Reach');
  for (let i = 1; i <= 20; i++) {
    let column = worksheet.getColumn(i);
    column.width = 20;
  }

  worksheet.addRow([]);
  const title1 = worksheet.addRow(['SD Movement Growth and Reach']);
  title1.font = {size: 16, bold: true};
  title1.alignment = {horizontal: 'center', vertical: 'middle'};
  worksheet.mergeCells(`A${title1.number}:T${title1.number}`);
  const title2 = worksheet.addRow([`${startYear} – ${endYear}`]);
  title2.font = {size: 12};
  title2.alignment = {horizontal: 'center', vertical: 'middle'};
  worksheet.mergeCells(`A${title2.number}:T${title2.number}`);

  worksheet.addRow(['']);
  let rowd1 = worksheet.addRow(['', '', '', '', '', '', '', '', 'Stats', '', '', '', '', '', '', '', '', '', '', '']);
  rowd1.alignment = {horizontal: 'center', vertical: 'middle'};
  rowd1.border = {
    top: {style: 'thin'},
    left: {style: 'thin'},
    right: {style: 'thin'},
    bottom: {style: 'thickThinRest'}
  };
  rowd1.fill = {
    type: 'pattern',
    pattern: 'solid',
    fgColor: {argb: 'cccacf'}
  };
  let rowd2 = worksheet.addRow(['', '', '', '', '', '', '', '', 'Current', '', '', 'Lifetime', '', '', '', '', 'Current Breakdown', '', '', '']);
  rowd2.alignment = {horizontal: 'center', vertical: 'middle'};
  rowd2.border = {
    top: {style: 'thin'},
    left: {style: 'thin'},
    right: {style: 'thin'},
    bottom: {style: 'thickThinRest'}
  };
  rowd2.fill = {
    type: 'pattern',
    pattern: 'solid',
    fgColor: {argb: 'cccacf'}
  };

  let rowd3 = worksheet.addRow(['Organization', 'Active Audience', '', 'Total in Discipleship', 'Lifetime Starts', '', 'Potential Leaders', '', 'Penetration', 'Completion', '', 'Completion', 'Replication', 'Stall Rate', 'Drop Rate', '', 'Year One', 'Year Two', 'Year Three', 'Leading']);
  rowd3.alignment = {horizontal: 'center', vertical: 'middle'};
  rowd3.border = {
    top: {style: 'thin'},
    left: {style: 'thin'},
    right: {style: 'thin'},
    bottom: {style: 'thickThinRest'}
  };
  rowd3.fill = {
    type: 'pattern',
    pattern: 'solid',
    fgColor: {argb: 'cccacf'}
  };

  worksheet.mergeCells('A1:T1');
  worksheet.mergeCells('I5:O5');
  worksheet.mergeCells('I6:J6');
  worksheet.mergeCells('L6:O6');
  worksheet.mergeCells('Q6:T6');

  let rowIndex = worksheet.lastRow.number + 1;
  Object.entries(reportData).filter(([key]) => !['startYear', 'endYear'].includes(key)).forEach(([orgName, orgData]) => {
  // Skip invalid keys
  if (!orgData?.activeAudienceCount && !orgData?.totaInDiscipleshipCount && !orgData?.lifeTimeStartsCount && !orgData?.potentialLeadersCount && !orgData?.breakdown) return;

  const row = worksheet.getRow(rowIndex);
   row.values = [
      orgName,
      orgData?.activeAudienceCount ?? 0,
      '',
      orgData?.totaInDiscipleshipCount ?? 0,
      orgData?.lifeTimeStartsCount ?? 0,
      '',
      orgData?.potentialLeadersCount ?? 0,
      '',
      `${parseFloat(orgData?.penetrationPercentage ?? 0).toFixed(2)}%`,
      `${parseFloat(orgData?.currentCompletionPercentage ?? 0).toFixed(2)}%`,
      '',
      `${parseFloat(orgData?.lifetimeCompletionPercentage ?? 0).toFixed(2)}%`,
      `${parseFloat(orgData?.replicationPercentage ?? 0).toFixed(2)}%`,
      orgData?.stallRatePercentage ?? 0,
      `${parseFloat(orgData?.dropRatePercentage ?? 0).toFixed(2)}%`,
      '',
      orgData?.breakdown?.D1 ?? 0,
      orgData?.breakdown?.D2 ?? 0,
      orgData?.breakdown?.D3 ?? 0,
      orgData?.breakdown?.Leading ?? 0
    ];

  row.alignment = {horizontal: 'center', vertical: 'middle'};
  row.border = {
    top: {style: 'thin'},
    left: {style: 'thin'},
    right: {style: 'thin'},
    bottom: {style: 'thin'}
  };
  row.height = 20;
  rowIndex++;
});

  // Generate the Excel file
  workbook.xlsx.writeBuffer().then(buffer => {
    // Convert buffer to Blob
    const blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    });

    // Save Blob as file
    saveAs(blob, 'Organization_Reports.xlsx');
  });
}

// to get the key name by passing key's value
function getKeyByValue(obj, value) {
  for (let key in obj) {
    if (obj[key] == value) {
      return key;
    }
  }
  return null;
}

// has object key value in array of object
function hasValueInArrayObjectProp(array, key) {
  return array?.some(obj => obj?.[key]);
}

// merge two array into object
function mergeArraysIntoObject(array, array2) {
  const mergedObject = {};
  array2.forEach((item, index) => {
    // Store only those fields which are in array2
    mergedObject[item.id] = array[index]?.type === 'radio' ? (item?.answers ? item?.answers : '') : item?.answers?.length > 0 ? [...item.answers.split(',')] : [];
  });

  return mergedObject;
}

function getValueFromBooks(books, searchValue, returnValue) {
  for (let book of books) {
    if (book.value === searchValue) {
      return book[returnValue];
    }
  }
  return null;
}

function checkObjectAnyKeyHasValue(obj) {
  return Object.values(obj).some(value => value);
}

function getTimeZoneCode() {
  const fullTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone; // IANA, e.g. "America/New_York"
  // Primary: match the browser's IANA zone against the options — labels embed the IANA name
  // (e.g. "New York (America/New_York)"). The legacy short-name→offset match below never hit
  // ("EST" vs offset "GMT-5:00"), so every user silently defaulted to UTC.
  if (fullTimeZone) {
    const byIana = CONSTANTS.TIMEZONE_OPTIONS.find(option => option.value === fullTimeZone || (option.label || '').includes(fullTimeZone));
    if (byIana) return byIana.value;
  }
  // Fallback: legacy short-name / offset match.
  const now = new Date();
  const timeZoneCode = now
    .toLocaleTimeString('en-US', {
      timeZoneName: 'short',
      timeZone: fullTimeZone
    })
    .split(' ')[2];
  const timezone = CONSTANTS.TIMEZONE_OPTIONS.find(option => option.offset === timeZoneCode || option.value === timeZoneCode);
  return timezone?.value || 'UTC';
}

const normalizeUrl = (url) => {
  if (!url) return '';
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url;
  }
  return `https://${url}`;
};
function detectMobileFromPath(pathname) {
  return pathname.includes('/mobile');
}
function isMobile() {
  return /Android|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i.test(navigator.userAgent);
}

export { getTimeZoneCode, disableDatesByWeekDay, validateWebURL, checkObjectAnyKeyHasValue, isValidZipCode, validateEmail, isEmptyObjectValues, validatePhone, isSpecialCharacterIncludes, isValidFile, formatTime, capitalizeWords, mergeConsecutiveSteps, getOverallGrowthReport, getYearReport, getOrganisationReport, allFieldsHaveValue, getKeyByValue, mergeArraysIntoObject, isValidLocation, getValueFromBooks, hasValueInArrayObjectProp, normalizeUrl, detectMobileFromPath, isMobile };